import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import EmptyTableIcon from 'assets/icons/EmptyTableIcon';
import FooterMenu from 'components/Commons/FooterMenu';
import Header from 'components/Commons/Header';
import AuthPage from 'features/auth/pages/AuthPage';
import ChangePasswordPage from 'features/auth/pages/ChangePasswordPage';
import useGame from 'hooks/useGame';
import useUserDetail from 'hooks/useUserDetail';
import { GameResponseModel } from 'models';
import { useEffect, useMemo, useState } from 'react';
import { BsArrowLeft } from 'react-icons/bs';
import { platformStates } from 'redux/platformSlice';
import { upCommingLive } from 'utils/betUtils';
import { isLaptop, isPhone, isTablet } from 'utils/commonUtils';
import { compareCommenceTime } from 'utils/dateUtils';
import BetFormButton from '../components/BetForm/BetFormButton';
import TransactionModal from '../components/Modals/TransactionModal';
import StreamingGameItem from '../components/StreamingGameItem';
import {
  onChangeAuthPage,
  selectBets,
  selectFutureBets,
  selectGames,
  selectSelectedLiveGame,
  setSelectedLiveGame,
  setShowSubMenu,
} from '../homeSlice';
import StreamingGame from './StreamingGame';
import LoadingSpinner from 'components/Commons/LoadingSpinner';
import { useLocation, useNavigate } from 'react-router-dom';
import CloseIcon from 'assets/icons/CloseIcon';
import { IoIosMenu } from 'react-icons/io';
const LiveGame = () => {
  const { isUserLoggedIn } = useUserDetail();
  const games = useAppSelector(selectGames);
  const platform = useAppSelector(platformStates);
  const navigate = useNavigate();

  const location = useLocation();
  const game = location.state?.game as GameResponseModel;
  const [isShowChangePasswordForm, setIsShowChangePasswordForm] = useState<boolean>(false);
  const [isShowStream, setIsShowStream] = useState<GameResponseModel | null>(game);
  const selectedLiveGame = useAppSelector(selectSelectedLiveGame);
  const [isShowFooter, setIsShowFooter] = useState<boolean>(true);
  const dispatch = useAppDispatch();
  const t = useAppTranslation();
  const isPortrait = window.matchMedia('(orientation: portrait)').matches;
  const { isLoading } = useGame({
    league: '',
    size: 999,
  });
  const bets = useAppSelector(selectBets);
  const futureBets = useAppSelector(selectFutureBets);

  const closeForm = (): void => {
    dispatch(onChangeAuthPage(-1));
    dispatch(setShowSubMenu(false));
    setIsShowChangePasswordForm(false);
  };

  const onShowChangePasswordPage = () => {
    if (isUserLoggedIn) setIsShowChangePasswordForm(true);
  };

  const handleShowLiveGame = (game: GameResponseModel) => {
    setIsShowStream(game);
  };

  const handleCloseStream = () => {
    setIsShowStream(null);
  };

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (selectedLiveGame) {
      setIsShowStream(selectedLiveGame);
      dispatch(setSelectedLiveGame(null));
    }
  }, [selectedLiveGame, game, dispatch]);

  const filterGames: GameResponseModel[] = useMemo(() => {
    if (!games) return [];

    return games
      .filter((game) => game.status === 'LIVE' || upCommingLive(game.startDate))
      .sort((a, b) => {
        if (a.sport.group < b.sport.group) return -1;
        if (a.sport.group > b.sport.group) return 1;

        return compareCommenceTime(
          { id: a.id, startDate: a.startDate, isPinned: a.isPinned },
          { id: b.id, startDate: b.startDate, isPinned: b.isPinned },
        );
      });
  }, [games?.length]);

  const handleNavigateToBet = () => {
    if (isShowStream) {
      dispatch(setSelectedLiveGame(isShowStream));
    }
  };

  return (
    <div className="live-game-page relative">
      <i className="version">Version 1.0</i>

      <div className={`body-waraper`}>
        <Header isLiveGame onShowChangePasswordPage={onShowChangePasswordPage} />

        <div className="stream-container">
          <div className="list-game-container">
            {isShowStream && !(isPhone(platform) || isTablet(platform) || isLaptop(platform)) && (
              <div className="back-button">
                <BsArrowLeft
                  size={25}
                  onClick={handleCloseStream}
                  className="cursor-pointer primary-text-color"
                  style={{ marginLeft: '5px' }}
                />
              </div>
            )}

            {isShowStream ? (
              <StreamingGame game={isShowStream} />
            ) : (
              <div className="stream-game-list padding-wrapper">
                {isLoading && !games ? (
                  <div className="common-loading ">
                    <LoadingSpinner className="common-loading__body" />
                  </div>
                ) : filterGames.length > 0 ? (
                  filterGames.map((game) => (
                    <StreamingGameItem
                      key={game.id}
                      handlGameClick={handleShowLiveGame}
                      game={game}
                    />
                  ))
                ) : (
                  <EmptyTableIcon text={t('game.empty-live-game')} />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="menu-btn-container">
        <button className="menu-btn" onClick={() => setIsShowFooter((prev) => !prev)}>
          {isShowFooter ? (
            <CloseIcon isDarkMode={false} width="20" height="20" />
          ) : (
            <IoIosMenu width="20" height="20" />
          )}
        </button>
        {bets.length + futureBets.length !== 0 && !isShowFooter && (
          <p className="amount-odds">{bets.length + futureBets.length}</p>
        )}
      </div>
      {(isShowFooter || isPortrait) && (
        <FooterMenu
          isUserLogin={isUserLoggedIn}
          onShowChangePasswordPage={onShowChangePasswordPage}
          isLiveGame
          handlCloseStreaming={() => {
            if (isShowStream) {
              handleCloseStream();
            } else {
              handleBack();
            }
          }}
          handleOpenBet={handleNavigateToBet}
        />
      )}

      {!(isPhone(platform) || isTablet(platform) || isLaptop(platform)) && <BetFormButton />}

      <ChangePasswordPage isShow={isShowChangePasswordForm} closePage={closeForm} />
      <AuthPage />
      <TransactionModal />
    </div>
  );
};

export default LiveGame;
